export default __webpack_public_path__ + "Recoleta-Regular.woff2";